
export function checkCookie(): boolean {
    try {
      document.cookie = `__cookie_test__=1; path=/; SameSite=Lax`;
      const ok = document.cookie.includes('__cookie_test__=1');
      // cleanup
      document.cookie = `__cookie_test__=; Max-Age=0; path=/; SameSite=Lax`;
      return ok;
    } catch {
      return false;
    }
}